export const HTTP_STATUS_OK = 200;

export const HTTP_STATUS_UNAUTHORIZED = 401;

export const HTTP_STATUS_FORBIDDEN = 403;

export const HTTP_STATUS_NOT_FOUND = 404;

export const HTTP_STATUS_CONFLICT = 409;
